import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const STUDY_SCHEDULE_CONFIG = enabledOn(
  PlatformSlug.DATBooster,
  PlatformSlug.DATCrusher,
  PlatformSlug.OATBooster,
  PlatformSlug.INBDEBooster,
  PlatformSlug.NBDHEBooster,
  PlatformSlug.NDEBCrusher,
  PlatformSlug.GREBooster
)

export const isStudyScheduleAvailable = (slug?: PlatformSlug) => isFeatureAvailable(STUDY_SCHEDULE_CONFIG, slug)
